import React from 'react';
import { Button, ButtonGroup, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { serverManagementLogger } from '../utils/logger';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    const previousLanguage = i18n.language;
    i18n.changeLanguage(lng);
    serverManagementLogger.info('Language changed', { 
      from: previousLanguage, 
      to: lng 
    });
  };

  return (
    <Box>
      <ButtonGroup id="buttongroup" size="small" variant="outlined">
        <Button 
          onClick={() => changeLanguage('de')}
          variant={i18n.language.startsWith('de') ? 'contained' : 'outlined'}
        >
          DE
        </Button>
        <Button 
          onClick={() => changeLanguage('en')}
          variant={i18n.language.startsWith('en') ? 'contained' : 'outlined'}
        >
          EN
        </Button>
        <Button 
          onClick={() => changeLanguage('fr')}
          variant={i18n.language.startsWith('fr') ? 'contained' : 'outlined'}
        >
          FR
        </Button>
        <Button 
          onClick={() => changeLanguage('nl')}
          variant={i18n.language.startsWith('nl') ? 'contained' : 'outlined'}
        >
          NL
        </Button>
        <Button 
          onClick={() => changeLanguage('id')}
          variant={i18n.language.startsWith('id') ? 'contained' : 'outlined'}
        >
          ID
        </Button>
      </ButtonGroup>
    </Box>
  );
};

export default LanguageSwitcher; 